import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { createQuote } from "../QuoteService";
import { showToast } from "../../../../common/Toaster/Toaster";

const useCreateQuote = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: createQuote,
    onSuccess: (data) => {
      showToast("Quote created successfully", "success");
      // Without an entity id the update route would read "undefined" and the
      // entity read call would fail, so stay put instead.
      // createQuote returns the id as entity_id
      const quoteId = data?.entity_id ?? data?.entityid;
      if (quoteId) {
        navigate(`/order/quotes/update/${quoteId}`);
      }
    },
    onError: (error) => {
      showToast(
        error?.response?.data?.error_message || "Error while creating quote",
        "error"
      );
    },
  });
};

export default useCreateQuote;
